import { createSlice } from "@reduxjs/toolkit";
import { userAuditLogs } from "../actions/adminUserManagement.action";
import { InitialState } from "../interfaces/userManagement.interface";

const initialState: InitialState = {
  isLoading: false,
  data: null,
};

const getUserAuditLogs = createSlice({
  name: "Get User Audit Logs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userAuditLogs.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(userAuditLogs.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(userAuditLogs.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getUserAuditLogs.reducer;
